import React from 'react';
import { BrandMark } from '../ui/BrandLogo';

export function ShopLocationBrand({ city, className = '', as: Tag = 'p', markClassName = 'w-[32px]', tone = 'dark', cityOnly = false }) {
  return <Tag className={`mt-5 inline-flex items-center gap-2 text-lg font-black ${tone === 'light' ? 'text-krit-ink' : 'text-white'} ${className}`}>
    {!cityOnly && <BrandMark className={markClassName} />}
    <span>{!cityOnly && 'KRIT '}<span className="text-[var(--shop-accent)]">{city}</span></span>
  </Tag>;
}
